// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-url[data-v-49258307]  {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #F9F9FA;\n  padding: 10px;\n  font-size: 10px;\n}\n.input-url input[data-v-49258307] {\n  margin-left: 2px;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
